import request from '@/utils/request'

// 获取新客赠礼配置
export function getNewGuestGift(data) {
  return request({
    url: '/admin/activity/webNewGuestGift/get',
    method: 'post',
    data
  })
}

// 保存新客赠礼配置
export function saveNewGuestGift(data) {
  return request({
    url: '/admin/activity/webNewGuestGift/save',
    method: 'post',
    data
  })
}
